
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

//exports.install = function (Vue, options) {
const Common = {
    install(Vue, options) {

  Vue.prototype.GetLoginStaff = function () {
    var fakestaff = this.$conf.FakeStaff;
    //測試用
    if (fakestaff != null) {

      return fakestaff;
    }

    var value = "";
    var staff = null;

    var name = "scrmstaff";
    var arr = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]*)(;|$)")
    );

    if (arr != null) {
      value = unescape(arr[2]);
      staff = JSON.parse(value);
    }

    return staff;
  };

  Vue.prototype.GetTicket = function () {

    var fakestaff = this.$conf.FakeStaff;
    //測試用
    if (fakestaff != null) {
      return fakestaff.ticket;

    }

    var arr,
      reg = new RegExp("(^| )" + "scrmticket" + "=([^;]*)(;|$)");
    arr = document.cookie.match(reg);

    if (arr !== null) {
      return arr[2];

    }
    return "";
  };
  //轉UTC時間
  Vue.prototype.convertUTCDateToLocalDate = function (startTimeISOString) {
    var date = new Date(startTimeISOString);

    var yyyy = date.getFullYear();
    var dd = date.getDate();
    var mm = date.getMonth() + 1;

    if (dd < 10) dd = "0" + dd;

    if (mm < 10) mm = "0" + mm;

    var cur_day = yyyy + "-" + mm + "-" + dd;

    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    if (hours < 10) hours = "0" + hours;

    if (minutes < 10) minutes = "0" + minutes;

    if (seconds < 10) seconds = "0" + seconds;

    return cur_day + " " + hours + ":" + minutes + ":" + seconds;
  };

  //今天加幾天
  Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + days);
    return this;
  }

  Vue.prototype.formatDate = function (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  };

  function padLeftZero(str) {
    return ('00' + str).substr(str.length);
  }

  Vue.prototype.padLeft = function (str, lenght) {
    if (str.length >= lenght) {
      return str;
    } else {
      return this.padLeft("0" + str, lenght);
    }
  };

  Vue.prototype.initFirebase = function() {
    const firebaseConfig = {
      apiKey: "AIzaSyCyA8vB7GVjFTtE_yw3h23JEz2p99C79FI",
      authDomain: "scrmmessage.firebaseapp.com",
      projectId: "scrmmessage",
      storageBucket: "scrmmessage.appspot.com",
      messagingSenderId: "316115221927",
      appId: "1:316115221927:web:ce24743ffe277656618a82",
      measurementId: "G-GSXSMTGQMT"
    };
    
    console.log('initializeApp');
    const app = initializeApp(firebaseConfig);      
    
    console.log('getMessaging');
    const messaging = getMessaging(app);     
    
    console.log('requestPermission');
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted.');

        console.log('getting token');
        getToken(messaging, {vapidKey: "BG9TkhmoIxN12EQTOo-K41kQVb3FLZN2YJG1oYqb-WBQXTbOtLOqGNpYr3saSZnBAchjXJ28_pGnokfaYu_tFd4"})
        .then((currentToken) => {        
          if (currentToken) {
            console.log("got token:" + currentToken);
            this.sendTokenToServer(currentToken);
          } else {
            console.log(
              "no token"
            );
          }
        })
        .catch(err => {
          console.log("getToken fail", err);
        });
      }
    })
    .catch(err => {
      console.log('requestPermission fail', err);
      return false;
    });    
  }
}};

export default Common;


// WEBPACK FOOTER //
// ./src/common.js